import { StyledModal } from '../../../Modal/modal.styles'
import styled from 'styled-components'

export const CustomStyledModal = styled(StyledModal)`
  & .scrolling.content {
    background: ${props => props.theme.background};
  }
`
